'use strict';
import * as $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn from "./app.pages.-Documents-Create-Page$-Based-On.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion(docId) {
  this.Mc = null;
  this.Mc = docId;
}
export { $c_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion as $c_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion };
$p = $c_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion.prototype = new $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn.$h_Lapp_pages_DocumentsCreatePage$BasedOn();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion() {
}
export { $h_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion as $h_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion };
$h_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion)) {
    var x = this.Mc;
    var x$2 = x$0.Mc;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "OlderVersion";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Mc;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "docId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kn)));
}
export { $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion as $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion };
var $d_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion, "app.pages.DocumentsCreatePage$BasedOn$OlderVersion", ({
  kn: 1,
  fT: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion as $d_Lapp_pages_DocumentsCreatePage$BasedOn$OlderVersion };
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Based-On$-Older-Version.js.map
